module.exports = __webpack_public_path__ + "static/mobile-device-graphic-lg.4b5b9dfc.webp";